import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FlexView, Row, Button } from '@cuemath/comps';
import { openModal } from 'actions/modal';
import { MODAL_FORM } from 'constants/form';
import { ONLINE_PLAN_ACTIONS } from 'constants/pricing-management';
import MODAL from 'constants/modal';

const FullFlexView = styled(FlexView)`
  width: 100%;
`;

const Head = styled(Row)`
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
`;

const ButtonWrapper = styled(Button)`
  margin-left: 20px;
`;

class OnlinePlans extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      openModal: PropTypes.func.isRequired,
    }),
  };

  onClickOnlinePlans = heading => {
    const { actions } = this.props;

    actions.openModal(
      MODAL_FORM.ONLINE_PLANS_PRICING_MANAGEMENT_MODAL,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      {
        heading,
      },
    );
  };

  render() {
    const { UPDATE_EXISTING_PLANS, CREATE_DEACTIVATE_PLANS } = ONLINE_PLAN_ACTIONS || {};

    return (
      <FullFlexView justifyContent="center" alignItems="center">
        <Head alignItems="center" justifyContent="flex-start">
          <Button
            label={UPDATE_EXISTING_PLANS}
            onClick={() => this.onClickOnlinePlans(UPDATE_EXISTING_PLANS)}
          />
          <ButtonWrapper
            style={{}}
            label={CREATE_DEACTIVATE_PLANS}
            onClick={() => this.onClickOnlinePlans(CREATE_DEACTIVATE_PLANS)}
          />
        </Head>
      </FullFlexView>
    );
  }
}

export default connect(null, dispatch => ({
  actions: bindActionCreators(
    {
      openModal,
    },
    dispatch,
  ),
}))(OnlinePlans);
